"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _constants = require("../../../util/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var BaseStorageProvider = /*#__PURE__*/function () {
  function BaseStorageProvider() {
    _classCallCheck(this, BaseStorageProvider);

    this.save = (0, _debounce.default)(this._save, _constants.FORM_SUBMIT_DEBOUNCE_MS, {
      leading: true,
      trailing: false
    });
    this.delete = (0, _debounce.default)(this._delete, _constants.FORM_SUBMIT_DEBOUNCE_MS, {
      leading: true,
      trailing: false
    });
  }

  _createClass(BaseStorageProvider, [{
    key: "get",
    value: function get(dispatcher, callback) {
      callback(null, {
        body: {
          success: true,
          results: {}
        }
      });
    }
  }, {
    key: "_save",
    value: function _save(dispatcher, data, callback) {
      callback(null, {
        body: {
          success: true,
          result: data
        }
      });
    }
  }, {
    key: "_delete",
    value: function _delete(dispatcher, callback) {
      callback(null, {
        body: {
          success: true
        }
      });
    }
  }]);

  return BaseStorageProvider;
}();

exports.default = BaseStorageProvider;